import classNames from 'classnames';
import React from 'react';
import AccessibleDiv from 'components/AccessibleDiv/AccessibleDiv';
import Dropdown from 'components/Toolbar/Shared/Dropdown';
import * as Constants from 'const';
import styles from './styles.module.scss';

type Props = {
  currentHeadingTag: Constants.HeadingTagType | undefined;
  toggleHeadingTag: (tag: Constants.HeadingTagType) => void;
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>;
  onCloseDropdown?: () => void;
  dataTestId?: string;
};

const HeadingTagDropdown: React.FunctionComponent<Props> = (props) => {
  const { currentHeadingTag, toggleHeadingTag, onMouseEnter, onMouseLeave, onCloseDropdown, dataTestId = 'headingTag' } = props;

  return (
    <Dropdown className={styles.HeadingTag} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} dataTestId={`${dataTestId}-dropdown`}>
      {Constants.HEADING_TAGS.map((
        (headingTag, index) => {
          const className = classNames(styles.item, { [styles.active]: currentHeadingTag === headingTag });
          const onClick = (): void => toggleHeadingTag(headingTag);
          const onDoubleClick = (): void | undefined => onCloseDropdown && onCloseDropdown();

          return (
            <AccessibleDiv
              key={headingTag}
              className={className}
              onClick={onClick}
              onDoubleClick={onDoubleClick}
              data-testid={`${dataTestId}-item${index}`}>
              {headingTag.toUpperCase()}
            </AccessibleDiv>
          );
        }
      ))}
    </Dropdown>
  );
};

export default HeadingTagDropdown;
